import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  allContent: {
    display: 'flex',
    // justifyContent: 'space-around',
    width: '80%',

    margin: 'auto',
    backgroundColor: '#fff',
    '@media (max-width:1365px)': {
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'space-around',
      width: '100%',
      alignItems: 'center',
    },
    '@media (max-width:1024px)': {},
  },
  firstContent: {
    display: 'flex',
    width: '50%',
    color: '#000',
    flexDirection: 'column',
    webkitBoxShadow: '0px 3px 6px 0px rgba(0,0,0,0.27)',
    mozBoxShadow: '0px 3px 6px 0px rgba(0,0,0,0.27)',
    boxShadow: '0px 3px 6px 0px rgba(0,0,0,0.27)',
    padding: '20px ',
    '@media (max-width:1365px)': {
      webkitBoxShadow: 'none',
      mozBoxShadow: 'none',
      boxShadow: 'none',
      width: '80%',
      borderBottom: '1px solid #ECECEC',
    },
    '@media (max-width:1024px)': {
      width: '85%',
    },
    '@media (max-width:650px)': {
      width: '100%',
    },
    '& .MuiButton-contained ': {
      backgroundColor: '#55A7EE',
      color: '#fff',
      fontWeight: 'normal',
      '& span': {
        color: '#fff',
      },
    },
  },
  demandeAlignement: {
    display: 'flex',
  },
  colorText: {
    color: '#707070',
  },
  comment: {
    color: 'black',
    width: '90%',
  },
  titleBolder: {
    fontWeight: 'bolder',
    textTransform: 'uppercase',
    color: '#707070',
    paddingLeft: 20,
  },
  contentDemandeScnd: {
    marginTop: '20px',
    marginBottom: '10px',
    padding: '10px 0 10px 0',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid gray',
  },
  demandeContainer: {
    padding: '20px 0 20px 0',
    borderBottom: '1px solid gray',
  },
  contentButton: {
    width: '100%',
    paddingTop: 20,
    paddingBottom: 20,
    display: 'flex',
    borderBottom: '1px solid gray',
    '& button:nth-child(1)': {
      backgroundColor: '#55A7EE !important',
      padding: '0',
      color: '#fff !important',
    },
    '& Button:last-child': {
      padding: '0',
      border: '1px solid gray',
      color: '#6B6B6B !important',
      backgroundColor: '#fff !important',
    },
    '& span': {},
    '& :last-child span': {
      color: '#000',
      fontSize: 18,
    },
  },
  iconAdreser: {},
  addressContent: {
    display: 'flex',
    padding: '20px 0 20px 0',
    justifyContent: 'start',
    alignItems: 'center',
    '& :nth-child(1)': {
      display: 'flex',
      marginTop: '-12px',
      width: '28px',
      height: '42px',
      color: '#6B6B6B',
      marginRight: '20px',
    },
    '& :nth-child(2)': {
      width: '70%',
      color: '#6B6B6B',
    },
  },
  statusReservation: {
    padding: '20px 10px 20px 10px',
    fontSize: 12,
    borederRadius: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#E6E6E6',
    color: '#000',
    '& :first-child': {
      fontSize: 12,
    },
    '& :nth-child(2)': {
      backgroundColor: '#6B6B6B',
      padding: '0px 10px 0px 10px',
      lineHeight: '27px',
      borderRadius: 30,
      display: 'flex',
      justifyContent: 'center',
      fontSize: 12,
      width: '30%',
      color: '#fff',
    },
    '& :last-child': {
      fontSize: 12,
      width: '50%',
      textAlign: 'center',
    },
  },
  recapDate: {
    margin: '20px 10px 20px 0px ',
  },
  recapName: {
    margin: '0px 10px 10px 0px ',
  },
  separator: {
    width: '60%',
    display: 'flex',
    height: '1px',
    backgroundColor: '#fff',
    margin: '10px 0 10px 0 ',
  },
  contentDemande: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  scndContent: {
    width: '50%',
    '@media (max-width:1365px)': {
      webkitBoxShadow: 'none',
      mozBoxShadow: 'none',
      boxShadow: 'none',
      width: '100%',
      borderBottom: '1px solid #ECECEC',
    },
    '@media (max-width:1024px)': {
      width: '100%',
    },
    '@media (max-width:650px)': {
      width: '100%',
    },
  },
  button: {
    borderRadius: '5px',
    marginRight: '20px',
    width: '35%',
    padding: '0 !important',
  },
  secondContent: {
    padding: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: 'none',
    boxShadow: '0px 3px 6px 0px rgba(0,0,0,0.27)',
    mozBoxShadow: ' 0px 3px 6px 0px rgba(0,0,0,0.27)',
    webkitBoxShadow: '0px 3px 6px 0px rgba(0,0,0,0.27)',
    '& span': {
      fontSize: '16px',
      fontWeight: 600,
    },
    '@media (min-width:1025px) and (max-width:1365px)': {
      width: '75%',
    },
    '@media (max-width:1365px)': {
      justifyContent: 'center',
      margin: 'auto',
    },
    '& h6': {
      fontSize: 16,
      marginBottom: 20,
    },
  },
  resultContent: {
    fontSize: 14,
    display: 'flex',
    alignContent: 'center',
    // lineHeight: 0,
    alignItems: 'center',

    '& p': {
      fontSize: 12,
      paddingRight: 10,
      color: 'gray',
    },
  },
  contentRecat: {
    borderBottom: '1px solid gray',
    paddingTop: 10,
    paddingBottom: 10,
    borderTop: '1px solid gray',
    marginTop: '10px',
  },
  firstListChambre: {
    display: 'flex',
    fontWeight: 'bolder',
    justifyContent: 'space-between',
    '& h6': {
      fontSize: 16,
      fontWeight: 'bolder',
    },
    '&ul>li': {
      listStyle: 'none',
    },
  },
  listChambre: {
    listStyleType: 'none',
    padding: 0,
    fontSize: 12,
  },
  textTransormCapitalize: {
    textTransform: 'uppercase',
    paddingTop: '30px',
  },
  contentAsavoir: {
    fontSize: 14,
  },
  contentTotal: {
    border: 'none',
    boxShadow: 'unset',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '35px 0px 30px 0',
    padding: '10px',
    backgroundColor: '#58C6DE',
    color: '#fff',
  },
  contentPayment: {
    '& .MuiRadio-colorPrimary': {
      color: '#fff !important',
    },
    '& .MuiFormGroup-root': {
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      flexDirection: 'row',
      '& :first-of-type , :nth-child(2)': {
        padding: 0,
        margin: 0,
        color: '#000',
        textTransform: 'uppercase',
        fontWeight: 900,
        fontSize: 12,
        // marginLeft: 10,
        backgroundColor: 'unset',
        '& span': {
          paddingRight: 10,
        },
      },
    },
  },
  radioContainer: {
    width: '80%',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 2),
    color: theme.palette.background.paper,
    borderRadius: 6,
    '&:first-of-type': {
      backgroundColor: '#A7A7A7',
    },
    '&:last-of-type': {
      backgroundColor: '#58C6DE',
    },
    '& label': {
      width: '100%',
      color: '#fff',
    },
  },
  contntBtnRsrv: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '30px',
    '& :nth-child(2)': {
      width: '50%',
    },
  },
  firstButton: {
    color: '#000',
    backgroundColor: '#CAD1DE',
    marginRight: '15px',
    maxWidth: '109px',
    '&:hover': {
      backgroundColor: '#B4B9C4',
    },
  },
}));
